import {
  AbstractLiveSession,
  ArticleType,
  HttpMethods,
  mapToCard,
} from "@kvix/shared";
import { CardList } from "@kvix/ui";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { KvixUserContext } from "../../../../contexts/user";
import { useSocketEvent } from "../../../../hooks/socket";
import { Card } from "../../../partials/Content/Card";

interface Props {
  sessions: AbstractLiveSession[];
}
export const MobileStreamingNow: React.FC<Props> = (props) => {
  const { t, ready } = useTranslation("startPage");
  const [sessions, setSessions] = useState(props.sessions);
  const { user, actions } = useContext(KvixUserContext);

  const reloadSessions = async () => {
    const response = await fetch(`/api/session/current`, {
      method: HttpMethods.GET,
    });

    if (response.ok) {
      setSessions(await response.json());
    } else {
      throw new Error("Could not fetch current sessions");
    }
  };

  useSocketEvent("session state updated", () => {
    reloadSessions();
  });

  if (!ready) {
    return null;
  }

  return (
    <>
      {sessions?.length > 0 && (
        <CardList
          title={t("feeds.sessions.streamingNow")}
          titleUrl="/sessions"
          isStartpage
          slidesPerView={1}
          slideFullWidth
          loop={sessions?.length > 1}
          paginationButtons={sessions?.length > 1}
        >
          {sessions?.map((session) => (
            <Card
              fullWidth
              wide
              type={ArticleType.SESSION}
              options={mapToCard({ session })}
              key={session.id}
              displayDateLabel
              toggleFavourite={
                user
                  ? () =>
                      actions.toggleFavourite({
                        session,
                      })
                  : null
              }
            />
          ))}
        </CardList>
      )}
    </>
  );
};
